<template>
  <section id="tutorial" class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">TUTORIAL</span><br><span class="Head__main_jp">利用方法とコツ</span>
      </h2>
      <p class="_l-lg _mg-b20">
        マインドフルネスを初めてから効果を実感するまで大切な4ステップ「実践する」「習慣化する」「振り返って実感する」「深める」の解説と、それぞれのステップでのマイページ・アプリの各機能の利用方法を動画付きで紹介しています。
      </p>
      <p class="_mg-b40-30">
        <a href="https://www.the-melon.com/mypage_tutorial/" class="Link__line" target="_blank">詳細はこちらをご覧ください。</a>
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Tutorial'
}
</script>
